import { Suspense } from "react";
import { AccessForm } from "./access-form";

export const dynamic = "force-dynamic";

export default function AccessPage() {
  return (
    <main className="flex min-h-screen items-center justify-center px-5 py-12">
      <section className="w-full max-w-md rounded-3xl border border-white/10 bg-[#101016]/90 p-8 text-center shadow-2xl shadow-black/40 backdrop-blur-xl sm:p-10">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-violet-400/30 bg-violet-500/10 text-xl text-violet-200">
          ▶
        </div>
        <h1 className="mt-5 text-2xl font-semibold tracking-tight text-white">EasyShot is private</h1>
        <p className="mt-2 text-sm leading-6 text-white/55">
          Enter the access password to preview the website.
        </p>
        <Suspense fallback={null}>
          <AccessForm />
        </Suspense>
      </section>
    </main>
  );
}
